/* eslint-disable new-cap */
import 'element-closest-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import { toggleHelper, expandHelper } from './util/data-helper';
import { toHTML } from './util/dom-util';
import { getRandomID } from './util/string-util';
import { imageLoadCheck } from './util/util';
import EventHandler from './_dependencyvendor/event-handler';
import commonFunc from './common';
import LoadingSpinner from './ui/loading-spinner';
import Tab from './ui/tab';
import Accordion from './ui/accordion';
import Dialog from './ui/dialog';
import DialogHOC from './ui/dialog-hoc';
import RangeSlider from './ui/range-slider';
import RangeSliderMulti from './ui/range-slider-multi';
import TooltipBox from './ui/tooltip-box';
// eslint-disable-next-line no-unused-vars
import iePolyfill from './iePolyfill';
// import FillChart from './charts/fill-chart';
import BarChart from './charts/bar-chart';

import Toast from './ui/toast';

smoothscroll.polyfill();

/**
 * UI 초기화 처리
 * @param {*} target
 * @param {*} UI
 * @param {*} options
 */
const UIInitializer = (target, UI, options = {}) => {
  const elements = document.querySelectorAll(target);
  elements.forEach(el => {
    if (!UI.getInstance(el)) {
      const ui = new UI(el, options);
      ui.init();
    }
  });
};

Tab.GLOBAL_CONFIG = {
  activeClass: 'is-active',
};
Accordion.GLOBAL_CONFIG = {
  activeClass: 'is-active',
};
Dialog.GLOBAL_CONFIG = {
  openClass: 'is-active',
  closeClass: 'is-deactive',
};
Toast.GLOBAL_CONFIG = {
  templateContainer: `<div class="c-toast"></div>`,
  templateBox: `<div class="c-toast__box">{{MESSAGE}}</div>`,
};

TooltipBox.GLOBAL_CONFIG = {
  showClass: 'is-active',
  hideClass: 'is-deactive',
};

const Alert = (message, callbacks = {}) => {
  const dialog = new DialogHOC({
    layout: `
      <div class="c-modal c-modal--alert" role="alert" aria-modal="true">
        <div class="c-modal__dialog">
          <div class="c-modal__content">
            <div class="c-modal__body">
              {{message}}
            </div>
            <div class="c-modal__footer">
              <div class="c-button-wrap u-mt--0">
                <button class="c-button c-button--lg c-button--primary c-button--w460" data-dialog-close>확인</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `,
    replacer: {
      '{{a11y}}': getRandomID(),
      '{{message}}': message,
    },
  });
  if (callbacks.open) {
    EventHandler.one(dialog.getElement(), Dialog.EVENT.OPEN, event => {
      callbacks.open.apply(event.component, []);
    });
  }
  if (callbacks.close) {
    EventHandler.one(dialog.getElement(), Dialog.EVENT.CLOSE, event => {
      callbacks.close.apply(event.component, []);
    });
  }
  if (callbacks.opened) {
    EventHandler.one(dialog.getElement(), Dialog.EVENT.OPENED, event => {
      callbacks.opened.apply(event.component, []);
    });
  }
  if (callbacks.closed) {
    EventHandler.one(dialog.getElement(), Dialog.EVENT.CLOSED, event => {
      setTimeout(() => {
        callbacks.closed.apply(event.component, []);
      }, 0);
    });
  }
  dialog.open();
};

const Confirm = (message, confirmCallback = null) => {
  const dialog = new DialogHOC({
    layout: `

  <div class="c-modal c-modal--alert" role="alertdialog" aria-modal="true">
    <div class="c-modal__dialog">
      <div class="c-modal__content">
        <div class="c-modal__body">
          {{message}}
        </div>
        <div class="c-modal__footer">
          <div class="c-button-wrap u-mt--0">
            <button class="c-button c-button--full c-button--gray" data-dialog-close>취소</button>
            <button class="c-button c-button--full c-button--primary" data-dialog-confirm>확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>

    `,
    replacer: {
      '{{a11y}}': getRandomID(),
      '{{message}}': message,
    },
  });

  EventHandler.one(dialog.getElement(), Dialog.EVENT.OPEN, event => {
    const confirm = dialog.getElement().querySelector('[data-dialog-confirm]');
    if (confirm) {
      EventHandler.one(confirm, 'click', () => {
        if (confirmCallback) {
          confirmCallback.apply(event.component);
        }
      });
    }
  });

  dialog.open();
};

const initialize = () => {
  // 탭
  UIInitializer('[data-ui-tab]', Tab);
  // 아코디언
  UIInitializer('[data-ui-accordion]', Accordion);

  // 슬라이더 싱글
  UIInitializer('.c-range:not(.multi) > .c-range__slider', RangeSlider);
  // 슬라이더 멀티
  UIInitializer('.c-range.multi > .c-range__slider', RangeSliderMulti);
  // 툴팁박스
  UIInitializer('[data-ui-tpbox]', TooltipBox);

  toggleHelper();
  expandHelper();
  commonFunc.initialize();

  return 'initialized';
};

/**
 * flatpickr 원본소스 수정없이 커스텀이 필요하기 때문에
 * 플러그인 함수를 한번 랩핑하여 처리해야 하는 작업을 일괄적으로 처리하고
 * 플러그인을 반환한다.
 * @param {*} el
 * @param {*} options
 * @returns
 */
const datePicker = (el, options = {}) => {
  if (!window.flatpickr) {
    alert(
      `
      from ktm.ui.js
      flatpickr.js(달력) 모듈을 찾을 수 없습니다.\n
      flatpickr 모듈을 로드해주세요.\n
      resources/js/portal/vendor/flatpickr.min.js
      `,
    );
    throw new Error(`
    flatpickr.js(달력) 모듈을 찾을 수 없습니다.\n
    flatpickr 모듈을 로드해주세요.\n
    <script src="../../resources/js/portal/vendor/flatpickr.min.js"></script>
    `);
  }
  commonFunc.datepickerValueBinder();
  return flatpickr(el, {
    onReady: function () {
      this.currentYearElement.parentNode.insertBefore(toHTML(`<span class="year-text">년</span>`), this.currentYearElement.nextSibling);
    },
    ...options,
  });
};

if (window.KTM) {
  console.warn('');
  console.warn('   [ktm.ui.js] Overloading!');
  console.warn('');
  console.warn('   이 경고 문구는 [ktm.ui.js] 파일이 중복으로 로드되는 경우에 출력됩니다.');
  console.warn('   중복로드를 찾아 제거하세요.');
  console.warn('');
} else {
  document.addEventListener('DOMContentLoaded', () => {
    let windowScrollY = 0;
    EventHandler.on(window, Dialog.EVENT.FIRST_OPEN, () => {
      document.body.style.overflow = 'hidden';
      windowScrollY = window.scrollY || window.pageYOffset;
    });

    EventHandler.on(window, Dialog.EVENT.LAST_CLOSE, () => {
      document.body.style.overflow = '';
      window.scrollTo(0, windowScrollY);
    });

    initialize();
    commonFunc.initFunc();
    EventHandler.trigger(document, 'UILoaded');
    console.log('UI Initialized!');
  });
}

const swiperA11y = (el, options = {}) => {
  if (!options.pagination) {
    options.pagination = {
      el: '.swiper-pagination',
      type: 'fraction',
    };
  }
  return new window.Swiper(el, {
    ...options,
    threshold: 10, // 10px 이상 움직여야 슬라이드 기능작동
    a11y: {
      nextSlideMessage: '다음 슬라이드',
      prevSlideMessage: '이전 슬라이드',
      firstSlideMessage: '첫번째 슬라이드',
      lastSlideMessage: '마지막 슬라이드',
    },
    on: {
      init: function () {
        const target = typeof el === 'string' ? document.querySelector(el) : el;
        // 오토플레이 버튼이 있는 경우
        if (options.autoplay) {
          const autoPlayButton = target.querySelector('.swiper-button-pause');

          if (autoPlayButton) {
            autoPlayButton.setAttribute('aria-pressed', false);
            autoPlayButton.removeAttribute('aria-prssed');
            autoPlayButton.removeAttribute('type');

            EventHandler.on(autoPlayButton, 'click', e => {
              const isPlayed = autoPlayButton.classList.contains('swiper-button-pause');
              if (isPlayed) {
                autoPlayButton.classList.remove('swiper-button-pause');
                autoPlayButton.classList.add('swiper-button-play');
                this.autoplay.stop();
              } else {
                autoPlayButton.classList.add('swiper-button-pause');
                autoPlayButton.classList.remove('swiper-button-play');
                this.autoplay.start();
              }
              autoPlayButton.setAttribute('aria-pressed', isPlayed);
            });
          }
        }
        const slides = this.slides;
        const swiper = this;
        const wrapper = this.el;
        [].forEach.call(slides, (el, i) => {
          const elTarget = options.a11yTarget ? el.querySelector(options.a11yTarget) : el;
          if (options.noMessage !== true) {
            elTarget.appendChild(toHTML(`<span class="c-hidden">총 ${slides.length} 장의 슬라이드 중 ${i + 1} 번째 슬라이드입니다.</span>`));
            // elTarget.setAttribute('aria-label', '총' + slides.length + '장의 슬라이드 중 ' + (i + 1) + '번째 슬라이드입니다.');
          }

          elTarget.setAttribute('tabindex', 0);
          EventHandler.on(elTarget, 'focusin', () => {
            setTimeout(() => {
              wrapper.scrollLeft = 0;
              swiper.slideTo(i, 100);
            }, 0);
          });
        });

        if (options.init) {
          options.init.apply(this);
        }
      },
      afterInit: function () {
        if (options.afterInit) {
          options.afterInit.apply(this);
        }
      },
      ...options.on,
    },
  });
};

const a11yChecker = () => {
  const tabChecker = () => {
    const tabs = document.querySelectorAll('[data-ui-tab]');
    console.warn('-------------------> a11y Check! <-------------------');
    console.warn(`현재 검사된 탭 개수: ${tabs.length}개`);

    tabs.forEach(tab => {
      const tablist = tab.querySelectorAll('[role="tablist"]');

      if (tablist.length > 0) {
        tablist.forEach(el => {
          console.log('-----------------------------------------------------');
          console.log(`  1. role="tablist": ✅`);
          const roleTab = el.querySelectorAll('[role="tab"]');

          roleTab.forEach(ta => {
            const cId = ta.getAttribute('id');
            const sameId = document.querySelectorAll(`#${cId}`);
            if (sameId.length > 1) {
              console.log(`       found the same ID --> ${cId} ❌`);
            }
            console.log(`    > ${ta.textContent}`);
            console.log(`       [header] role="tab" ✅`);
            console.log(`       [header] id="${ta.getAttribute('id')}" ✅`);
            const contentPanelID = ta.getAttribute('aria-controls');
            const contentPage = document.querySelector(`#${contentPanelID}`);
            if (contentPage) {
              console.log(`       [header] aria-controls=${ta.getAttribute('aria-controls')} ✅`);
              if (contentPage.getAttribute('role') === 'tabpanel') {
                console.log(`       [content] role="tabpanel" ✅`);
                console.log(`       [content] id="${contentPage.getAttribute('id')}" ✅`);
              } else {
                console.log(`       [content] role="tabpanel" ❌`);
              }

              if (contentPage.getAttribute('aria-labelledby') === cId) {
                console.log(`       [content] aria-labelledby="${cId}" ✅`);
              } else {
                console.log(`       [content] aria-labelledby="${cId}" ❌`);
              }
            } else {
              console.log(`       [header] aria-controls=${ta.getAttribute('aria-controls')} ❌`);
            }

            if (ta.getAttribute('aria-selected') === 'false') {
              if (contentPage.offsetWidth < 1 && contentPage.offsetHeight < 1) {
                console.log(`       [header] aria-selected=${ta.getAttribute('aria-selected')} ✅`);
              } else {
                console.log(`       [header] aria-selected=${ta.getAttribute('aria-selected')} ❌`);
              }
            } else {
              if (contentPage.offsetWidth < 1 && contentPage.offsetHeight < 1) {
                console.log(`       [header] aria-selected=${ta.getAttribute('aria-selected')} ❌`);
              } else {
                console.log(`       [header] aria-selected=${ta.getAttribute('aria-selected')} ✅`);
              }
            }
          });
        });
      } else {
        console.warn(`  1. role="tablist": OK!`);
      }
    });
  };
  tabChecker();
};

const ui = {
  initialize,
  Tab,
  Dialog,
  Alert,
  Confirm,
  Accordion,
  datePicker,
  swiperA11y,
  RangeSlider,
  RangeSliderMulti,
  LoadingSpinner,
  // FillChart,
  BarChart,
  Toast,
  a11yChecker,
  imageLoadCheck,
};

window.KTM = { ...ui };
